/* global G */
import { curry, isStr } from 'lib/util'

const descriptor = 'model::decorator::fromObject'

/**
 * From Object Decorator
 *
 * Converts G.CACHE object to a stringified JSON.
 *
 * @param {string} key          the name of the attribute to store the data to
 * @param {Gaia.Model.Spec} obj the current model object composition
 * @param {Object} component    the component that matched the attribute name during the mapping
 */
const fromObject = (key, obj, component) => {
  const source = obj[G.CHILDREN][key]
  const cache = source[G.CACHE]
  // if it already is a string, it means it has been already decorated
  try {
    cache && !isStr(source[G.CACHE]) && (source[G.CACHE] = JSON.stringify(cache, null, 2))
  } catch (e) {
    console.log(descriptor, e)
  }
  return component
}

export default curry(fromObject)
